import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@mui/material/Box';
import { translate } from '../i18n/customI18nProvider';
import { useTheme } from '@mui/material/styles';
import { withStyles } from '@material-ui/core/styles';

const JsonModalField = ({ source, label }) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const data = record && record[source];

    if (!data) return null;

    // On s'assure que la donnée est un objet pour le formatage
    let displayData = data;
    if (typeof data === 'string') {
        try {
            displayData = JSON.parse(data);
        } catch (e) {
            displayData = { error: "Format JSON invalide", raw: data };
        }
    }

    const handleOpen = (e) => {
        e.stopPropagation(); // Évite de trigger le clic sur la ligne de la Datagrid
        setOpen(true);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setOpen(false);
    };

    return (
        <>
            <Button 
                size="small"
                startIcon={<VisibilityIcon />} 
                onClick={handleOpen}
                color="primary"
            >
                {translate('custom.show_details')}
            </Button>

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>{label || ""}</DialogTitle>
                <DialogContent dividers>
                    <Box 
                        component="pre" 
                        sx={{ 
                            backgroundColor: '#f5f5f5', 
                            padding: 2, 
                            borderRadius: 1, 
                            overflowX: 'auto',
                            fontFamily: 'monospace',
                            fontSize: '0.875rem'
                        }}
                    >
                        {JSON.stringify(displayData, null, 2)}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">{translate('custom.close')}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default JsonModalField;